import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { styled } from "styled-components";
import { breakpoint, theme } from "@utilities";

interface IProps {
    isChecked?: boolean;
}

export const CheckBoxCommon = ({ isChecked }: IProps) => {
    return (
        <Container>
            <Checkbox
                checked={isChecked || false}
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        {/* background box */}
                        <rect x="0" y="0" width="24" height="24" rx="4" fill={theme.colors.main} />
                        {/* check mark */}
                        <path
                            d="M6 12l4 4 8-8"
                            stroke={theme.colors.button_text}
                            strokeWidth="2"
                            fill="none"
                        />
                    </svg>
                }
            />
        </Container>
    );
};

const Container = styled.div`
    .PrivateSwitchBase-root-1 {
        padding: 5px;
        ${breakpoint.breakLarge`
      padding: 9px;
    `}
    }

    .MuiSvgIcon-root {
        width: 0.7em;
        height: 0.7em;
        ${breakpoint.breakLarge`
      width: 1em;
      height: 1em;
    `}
    }
`;
